import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {IPlatformToolComponent, IPlatformToolHandler} from '@shared/components/platform-tool/platform-tool-container/platform-tool-component';
import {InvalidateSubject} from '@shared/helpers/invalidate.subject';
import {MagicLinkModel, TabModel} from '@shared/models/platform-tool-models';
import {Subject} from 'rxjs';
import { FuseSplashScreenService } from '@barebone-fuse-services/splash-screen.service';
import {PlatformCommandResponse} from '@shared/commands/command-base';

@Component({
    standalone: false,
    selector: 'particle-platform-tool-rich-document-editor',
  templateUrl: './platform-tool-rich-document-editor.component.html',
  styleUrls: ['./platform-tool-rich-document-editor.component.scss']
})
export class PlatformToolRichDocumentEditorComponent implements OnInit, OnDestroy, IPlatformToolComponent {
  handler: IPlatformToolHandler;
  invalidateSubject: InvalidateSubject;
  magicLinkModel: MagicLinkModel;
  selectedTab: TabModel;
  ngUnsubscribe = new Subject<void>();

  ckeditorContent: any;
  ckeConfig: any;
  private changed: boolean;

  constructor(private fuseSplashScreenService: FuseSplashScreenService) {
    this.ckeConfig = {
      allowedContent: false,
      forcePasteAsPlainText: true,
      removePlugins: 'horizontalrule,tabletools,specialchar,about,list,others',
      //removeButtons: 'Save,NewPage,Preview,Print,Templates,Replace,SelectAll,Form,Checkbox,Radio,TextField,Textarea,Find,Select,Button,ImageButton,HiddenField,CopyFormatting,CreateDiv,BidiLtr,BidiRtl,Language,Flash,Smiley,PageBreak,Iframe,Font,FontSize,TextColor,BGColor,ShowBlocks,Cut,Copy,Paste,Table,Image,Format,Source,Maximize,Styles,Anchor,SpecialChar,PasteFromWord,PasteText,Scayt,Strike,RemoveFormat,Blockquote,Subscript,Superscript,Link,Unlink,Indent,Outdent'
    };
  }

  ngOnInit() {

  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  onAfterExecuteNextCommand(nextCommandResponse: PlatformCommandResponse) {
  }

  onAfterExecutePreviousCommand(previousCommandResponse: PlatformCommandResponse) {
  }

  onBeforeExecuteNextCommand(): boolean {
    return true;
  }

  onBeforeExecutePreviousCommand(): boolean {
    return true;
  }

  onLoad() {
  }
  onChange($event: any) {
    this.changed = true;
    this.magicLinkModel.breadcrumbBar.items[0].commands[0].isDisabled = false;
  }
  onEditorChange($event: any) {

  }
  onReady($event: any) {

  }

  onFocus($event: any) {

  }

  onBlur($event: any) {

  }

  onContentDom($event: any) {

  }

  onFileUploadRequest($event: any) {

  }

  onFileUploadResponse($event: any) {

  }

  onPaste($event: any) {

  }

  onDrop($event: any) {

  }
}
